var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExerciseWritting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_388_6227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4043 6.10059L21.5243 6.16992C22.5618 6.76887 23.427 7.26832 24.0605 7.75718C24.7291 8.27317 25.2598 8.86543 25.4821 9.69501C25.7044 10.5246 25.5409 11.3029 25.2198 12.084C24.997 12.6263 24.6693 13.2356 24.2744 13.9306L23.4274 13.4271L23.4164 13.4207L14.1827 8.08962L13.3192 7.58068C13.7193 6.89922 14.0798 6.31718 14.4347 5.85725C14.9507 5.18861 15.543 4.65791 16.3726 4.43562C17.2021 4.21334 17.9804 4.37681 18.7616 4.69788C19.5017 5.00206 20.3668 5.50157 21.4043 6.10059Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3173 9.3117L7.67998 17.3436C7.28294 18.03 6.96899 18.5727 6.85267 19.1901C6.73636 19.8074 6.83128 20.4272 6.95132 21.211L6.98366 21.4229C7.20524 22.878 7.38788 24.0774 7.66335 24.987C7.95144 25.9382 8.39432 26.7616 9.26534 27.2645C10.1364 27.7674 11.0709 27.7392 12.0387 27.5131C12.9641 27.2969 14.0942 26.8553 15.4651 26.3197L15.6648 26.2417C16.4036 25.9538 16.9878 25.7261 17.4643 25.3167C17.9408 24.9073 18.2538 24.364 18.6498 23.677L23.2761 15.6638L22.4109 15.1496L13.1711 9.81495L12.3173 9.3117Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1365 8.62477L12.5712 8.88096L13.423 9.38308L22.6609 14.7166L22.6664 14.7198L22.6664 14.7198L23.5316 15.234L23.9559 15.4863L23.7091 15.9138L19.083 23.9266L19.0828 23.927L19.0587 23.9688C18.6824 24.622 18.3319 25.2305 17.7902 25.6959L17.4643 25.3167L17.7902 25.6959C17.2485 26.1614 16.5942 26.4163 15.8917 26.6899L15.8466 26.7075L15.8464 26.7076L15.6471 26.7854L15.6469 26.7855L15.6138 26.7984C14.2701 27.3234 13.1129 27.7756 12.1525 28C11.1288 28.2391 10.0447 28.2918 9.01535 27.6975C7.98599 27.1032 7.48952 26.138 7.18481 25.1319C6.89893 24.188 6.7119 22.9597 6.49474 21.5335L6.48938 21.4983L6.48936 21.4981L6.45708 21.2867L6.45704 21.2865L6.44971 21.2386C6.33548 20.4935 6.22908 19.7994 6.36132 19.0975C6.49356 18.3956 6.84525 17.7878 7.22282 17.1353C7.23086 17.1214 7.23891 17.1075 7.24697 17.0936L12.1365 8.62477ZM12.1365 8.62477L11.8843 9.0617L7.24718 17.0932L12.1365 8.62477ZM24.019 14.3604L24.4573 14.6209L24.7092 14.1776C25.1046 13.4815 25.4463 12.8482 25.6823 12.2741C26.0245 11.4414 26.2271 10.5434 25.9651 9.5656C25.7031 8.5878 25.0787 7.91135 24.3659 7.36134C23.7058 6.85195 22.8169 6.33875 21.8016 5.75262L21.7743 5.7369L21.7743 5.73689L21.6543 5.66758L21.6543 5.66758L21.627 5.65185C20.6118 5.06565 19.7228 4.55237 18.9517 4.23541C18.119 3.89318 17.221 3.69066 16.2432 3.95266C15.2653 4.21466 14.5889 4.83907 14.0389 5.55178L14.4347 5.85725L14.0389 5.55179C13.663 6.03886 13.2889 6.64482 12.888 7.32751L12.6353 7.75797L13.0653 8.01143L13.9288 8.52037L13.9288 8.52039L13.9327 8.52263L23.1637 13.8521L23.1664 13.8537L23.1719 13.8569L23.1746 13.8585L24.019 14.3604Z",
    stroke: "url(#paint0_linear_388_6227)",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_388_6227",
    x: -18.1997,
    y: -20.667,
    width: 68.7842,
    height: 73.3354,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_388_6227"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_388_6227",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_388_6227",
    x1: 6.7998,
    y1: 4.33325,
    x2: 29.6032,
    y2: 22.6712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExerciseWritting);
export default __webpack_public_path__ + "static/media/exercise-writting.04a80880bf45effeb3d039574b1e377d.svg";
export { ForwardRef as ReactComponent };